import { Routing } from "pages";
import { Provider } from "react-redux";
import { withProviders } from "./providers";

import ThemeContextWrapper from "shared/lib/theme";

import "./styles/index.less";
import { store } from "store";
import {CookieConsent} from "react-cookie-consent";

function App() {
  return (
    <ThemeContextWrapper>
      <Provider store={store}>
        <Routing />
          <CookieConsent
              location="bottom"
              buttonText="Я принимаю"
              cookieName="myAwesomeCookieName2"
              style={{ background: "#FFFFFF" }}
              buttonStyle={{ background: "#090", fontSize: "13px", color:"#FFFFFF" }}
              expires={150}
          >
              <span style={{color: '#333333'}}>Мы используем файлы cookie и рекомендательные технологии. Пользуясь сайтом, вы соглашаетесь с Политикой обработки персональных данных{" "}</span>
          </CookieConsent>
      </Provider>
    </ThemeContextWrapper>
  );
}

export default withProviders(App);
